/** Constantes compartilhadas entre API, worker e front-end (seguras para o navegador). */

export const UPLOAD_LIMITS = {
  maxPdfBytes: 50 * 1024 * 1024,
  maxPages: 300,
} as const;

export const ROLES = ["admin", "teacher", "facilitator", "student"] as const;
export type Role = (typeof ROLES)[number];

export const ROLE_LABELS: Record<Role, string> = {
  admin: "Administrador da instituição",
  teacher: "Professor",
  facilitator: "Facilitador",
  student: "Aluno",
};

/**
 * Perfis selecionáveis, do menor para o maior acesso. Combinam a situação da conta, o perfil na
 * instituição e a administração da plataforma, que fica acima de todas as instituições.
 */
export const PROFILES = ["pending", "student", "facilitator", "teacher", "admin", "platform_admin"] as const;
export type Profile = (typeof PROFILES)[number];

export const PROFILE_LABELS: Record<Profile, string> = {
  pending: "Aguardando liberação",
  student: "Aluno",
  facilitator: "Facilitador",
  teacher: "Professor",
  admin: "Administrador da instituição",
  platform_admin: "Administrador da plataforma",
};

/** Perfil exibido a partir dos campos da conta. */
export function profileOf(u: { role: Role; status: string; isPlatformAdmin: boolean }): Profile {
  if (u.status === "pending") return "pending";
  if (u.isPlatformAdmin) return "platform_admin";
  return u.role;
}

/** Campos da conta que correspondem a cada perfil. */
export function profileFields(p: Profile): { role: Role; isPlatformAdmin: boolean; pending: boolean } {
  if (p === "pending") return { role: "student", isPlatformAdmin: false, pending: true };
  if (p === "platform_admin") return { role: "admin", isPlatformAdmin: true, pending: false };
  return { role: p, isPlatformAdmin: false, pending: false };
}

export const LEVELS = ["beginner", "intermediate", "advanced"] as const;
export type Level = (typeof LEVELS)[number];

export const LEVEL_LABELS: Record<Level, string> = {
  beginner: "Iniciante",
  intermediate: "Intermediário",
  advanced: "Avançado",
};

export const RIGHTS_BASIS = ["owner", "licensed", "public_domain"] as const;
export type RightsBasis = (typeof RIGHTS_BASIS)[number];

export const RIGHTS_LABELS: Record<RightsBasis, string> = {
  owner: "Sou autor(a) ou titular dos direitos do ebook",
  licensed: "Tenho licença ou autorização para usar o ebook",
  public_domain: "O ebook está em domínio público ou sob licença aberta",
};

export const SESSION_TTL_DAYS = 14;
export const PASSWORD_RESET_TTL_MINUTES = 60;

/** Estimativa simples de tokens (≈ 4 caracteres por token em português). */
export const estimateTokens = (text: string): number => Math.ceil(text.length / 4);

/** Motivo gravado quando o professor interrompe a geração do curso. */
export const GENERATION_CANCELLED_MESSAGE = "Geração interrompida pelo professor.";
